<div class="calendar-container">
    <div class="flex items-center justify-between">
        <div class="flex items-center gap-2">
            <h1>Kalender</h1>
            <mat-spinner [diameter]="30" mode="indeterminate" *ngIf="(loading$ | async)"></mat-spinner>
        </div>
        <div *ngIf="(user$ | async).roles.includes('ROLE_ADMIN')">
            <mat-checkbox (change)="isManaged($event.checked)">
                nur verwaltet Infulencer Termine anzeigen
            </mat-checkbox>
        </div>

    </div>
    <div style="position: relative">
        <full-calendar [options] = "calendarOptions" class="custom-calendar" #fullcalendar >
            <ng-template #eventContent let-arg  >
                <div class="relative calendar-day-color p-2" *ngIf="arg.event.extendedProps as artist" [ngStyle]="{ '--calendar-day-color': artist.eventColor }">
                    <div class="relative w-8 rounded-full" >
                        <div class="media aspect-1-1 rounded-full bg-gray-200">
                            <div class="overlay full" *ngIf="!artist.filename">
                                <img class="contain rounded" [src]="getAvatar(artist.name)" alt=""/>
                            </div>
                            <div class="overlay full" *ngIf="artist.filename">
                                <img class="contain rounded" [src]="artist.filename" alt=""/>
                            </div>
                        </div>
                        <div class="absolute bottom-0 right-0 -mr-1 -mb-1 w-4 rounded-full border-2 border-white" *ngIf="artist.logo as logo">
                            <div class="media aspect-1-1 rounded-full bg-gray-300">
                                <div class="overlay full rounded-full bg-cover bg-center" [style.background-image]="'url(' + logo + ')'">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </ng-template>
        </full-calendar>
        <div class="view-select">
            <mat-form-field appearance="outline"  [style.width]="selectWidth">
                <mat-select [(ngModel)]="currentView" #matSelect [panelWidth]="null" (ngModelChange)="changeView()">
                    <mat-option *ngFor="let option of viewOptions" [value]="option.value">
                        {{ option.label }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <mat-select [(ngModel)]="eventTypes" multiple [panelWidth]="null" (ngModelChange)="loadData()">
                    <mat-option *ngFor="let ele of eventTypeList" [value]="ele.type" class="custom-option">
                        <span [ngStyle]="{'color': ele.color}">{{ ele.name }}</span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <!-- Custom Popover -->
        <div *ngIf="isPopoverVisible" class="popover">
            <div class="flex items-center justify-between p-2 text-gray-800 bg-gray-100">
                <h3 class="text-lg m-0">Termine am {{ popoverDate }}</h3>
                <button class="bg-transparent border-none text-lg cursor-pointer" (click)="closePopover()">✕</button>
            </div>
            <div class="flex items-center gap-2 p-3 flex-wrap">
                <div class="relative calendar-day-color p-2 cursor-pointer" *ngFor="let event of popoverData" [ngStyle]="{ '--calendar-day-color': event.eventColor }" (click)="onEventClick(event)">
                    <div class="relative w-8 rounded-full">
                        <div class="media aspect-1-1 rounded-full bg-gray-200">
                            <div class="overlay full" *ngIf="!event.filename">
                                <img class="contain rounded" [src]="getAvatar(event.name)" alt=""/>
                            </div>
                            <div class="overlay full" *ngIf="event.filename">
                                <img class="contain rounded" [src]="event.filename" alt=""/>
                            </div>
                        </div>
                        <div class="absolute bottom-0 right-0 -mr-1 -mb-1 w-4 rounded-full border-2 border-white" *ngIf="event.logo as logo">
                            <div class="media aspect-1-1 rounded-full bg-gray-300">
                                <div class="overlay full rounded-full bg-cover bg-center" [style.background-image]="'url(' + logo + ')'">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
